export default () => ({
  root: {
    display: 'flex',
  },
});
